<template>
  <div class="charts_el" ref="chartsEl"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "GjkcH5ScoreRadar",
  props: {
    color: {},
  },

  data() {
    return {};
  },

  mounted() {
    // this.initCharts();
  },

  methods: {
    initCharts(dataValue,indicator) {
      var chartDom = this.$refs.chartsEl;
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        backgroundColor: "#FFF",
        tooltip: {
          show: true,
        },
        radar: {
          radius: "60%",
          center: ["50%", "55%"],
          // startAngle: 0,
          splitNumber: 5,
          nameGap: 10, // 图和字的间距 默认15 number
          name: {
            textStyle: {
              color: "#000",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#E6E6E6",
            },
          },
          splitLine: {
            lineStyle: {
              width: 1,
              color: "#E6E6E6",
            },
          },
          splitArea: {
            areaStyle: {
              color: ["#fff"].reverse(),
            },
          },
          indicator: indicator,
        },
        series: [
          {
            name: "",
            type: "radar",
            symbolSize: 8,
            itemStyle: {
              borderColor: "#007AFF",
              borderWidth: 2,
            },
            areaStyle: {
              normal: {
                width: 1,
                opacity: 0.3,
              },
            },
            data: [
              {
                itemStyle: {
                  normal: {
                    color: "#0083FF",
                  },
                },
                value: dataValue,
              },
            ],
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.charts_el {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
